import React from 'react'
import { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../Firebase/Firebase';
import firebase from 'firebase/compat/app';
import { sendEmailVerification } from 'firebase/auth';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {

  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)


  const signUp = async (email, password, displayName) => {
    try {
      const { user } = await auth.createUserWithEmailAndPassword(email, password);
  
      // Create a document in the "users" collection with the user's information
      const userRef = await firebase.firestore().collection('users').doc(user.uid);
      const userProfile ={
        email: user.email,
        displayName: displayName || "Unknown",
        photoURL: user.photoURL || "https://firebasestorage.googleapis.com/v0/b/meteoyama-414fe.appspot.com/o/Images%2Fperson.png?alt=media&token=d3e23db0-c574-4195-8296-855d54ddac04",
        createdAt: new Date(),
        uid: user.uid,
        terms: "agreed",
        phoneNumber: "",
        subscribed: false,
        bio: "",
        country: "",
      };

         // If the user signs up using Google, upload the profile image to Firebase Storage
    if (user.providerData[0]?.providerId === 'google.com' && user.photoURL) {
      const response = await fetch(user.photoURL);
      const blob = await response.blob();
      const storageRef = firebase.storage().ref().child(`profile_images/${user.uid}`);
      await storageRef.put(blob);
      const downloadURL = await storageRef.getDownloadURL();
      userProfile.photoURL = downloadURL;
    } else {
      // If the user signs up using email and password, use a default image or leave it blank
      userProfile.photoURL =
        "https://firebasestorage.googleapis.com/v0/b/meteoyama-414fe.appspot.com/o/Images%2Fperson.png?alt=media&token=d3e23db0-c574-4195-8296-855d54ddac04";
    }

    // Set the user's profile data in Firestore
    await userRef.set(userProfile);
  
      // Send email verification
      await sendEmailVerification(auth.currentUser);
  
      // Log the message to the console after verification email is sent
      console.log("Go to your email inbox for verification");
  
      setCurrentUser(user);
  
    } catch (error) {
      console.error("Error creating user:", error);
    }
}

function signIn(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}



function logout() {
  return auth.signOut();
}

function resetPass(email) {
  return auth.sendPasswordResetEmail(email);
}

function updateEmail(email) {
  return currentUser.updateEmail(email);
}

function updatePassword(password) {
  return currentUser.updatePassword(password);
}




useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged((user) => {

    if (user) {
      setCurrentUser(user);
      Cookies.set('user', user, { expires: 7 }); // Store the user data in a cookie for 7 days
    } else {
      setCurrentUser(null);
      Cookies.remove('user'); // Remove the user cookie if the user is not authenticated
    }
  
    setLoading(false)
    setCurrentUser(user)
  

  })
  return unsubscribe;
}, [])

const value = {
  currentUser,
  signIn,
  signUp,
  logout,
  resetPass,
  updateEmail,
  updatePassword,
}
return (
  <AuthContext.Provider value={value}>
    {!loading && children}
  </AuthContext.Provider>
);
}
